import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import CP from "core/components/common";
import { uuid } from "core/utils/index";
import { border } from "polished";
import {
  HeaderGroup
} from "react-table";
import styled, { css } from "styled-components";

interface CustomHeaderGroup extends HeaderGroup {
    visible?: boolean;
}

interface Props {
  headerGroups?: CustomHeaderGroup[];
  rowCount?: boolean;
  isSort?: boolean;
  openDepth?: any;
  setOpenDepth?: (e: any) => void;
}

export default function SalaryTableHeader({
    headerGroups, 
    rowCount,
    isSort,
    openDepth,
    setOpenDepth
}: Props) {
    return (
        <thead style={{ zIndex: 2 }}>
              {headerGroups?.map((headerGroup: any) => (
                <tr {...headerGroup.getHeaderGroupProps()} key={uuid()}>
                  {rowCount && (
                    <th className="no">
                      <ThDiv>No</ThDiv>
                    </th>
                  )}

                  {headerGroup.headers.map((column: CustomHeaderGroup) => {
                    if (column?.visible === false) return;

                    const label: any = column.render("Header");

                    if (label === "번호")
                      return (
                        <th
                          key={uuid()}
                        >
                          <ThDiv>
                            {label}{" "}
                          </ThDiv>
                        </th>
                      );

                    // set 1
                    if (label === "월급여")
                      return (
                        <th
                          key={uuid()}
                          onClick={() =>
                            setOpenDepth({ ...openDepth, salary: !openDepth.salary })
                          }
                        >
                          <ThDiv>
                            {label}
                            {openDepth.salary ? (
                              <CP.Icon.MinusIcon />
                            ) : (
                              <CP.Icon.PlusIcon />
                            )}
                          </ThDiv>
                        </th>
                      );
                    if (["기본급", "시간외수당"].includes(label) ) {
                      return (
                        <th
                          {...column.getHeaderProps(column.getSortByToggleProps())}
                          key={uuid()}
                          className="subMenu "
                        >
                          <ThDiv>
                            {label}{" "}
                            {!column.disableSortBy && (
                            <span>
                              {column.isSorted
                                ? column.isSortedDesc
                                  ? <CaretDownOutlined /> // 내림차순
                                  : <CaretUpOutlined /> // 오름차순
                                : ""}
                            </span>
                          )}
                          </ThDiv>
                        </th>
                      );
                    }

                  // set 2
                  if (label === "수당")
                    return (
                      <th
                        key={uuid()}
                        onClick={() =>
                          setOpenDepth({ ...openDepth, extra: !openDepth.extra })
                        }
                      >
                        <ThDiv>
                          {label}
                          {openDepth.extra ? (
                            <CP.Icon.MinusIcon />
                          ) : (
                            <CP.Icon.PlusIcon />
                          )}
                        </ThDiv>
                      </th>
                    );
                  if (["상여금1", "연장근로수당", "휴일수당", "심야수당", '야근교대수당', "전월착오수당", "기타수당", "소급분", "연차수당"].includes(label)) {
                    return (
                      <th
                        {...column.getHeaderProps(column.getSortByToggleProps())}
                        key={uuid()}
                        className="subMenu "
                      >
                        <ThDiv>
                          {label}{" "}
                          {!column.disableSortBy && (
                          <span>
                            {column.isSorted
                              ? column.isSortedDesc
                                ? <CaretDownOutlined /> // 내림차순
                                : <CaretUpOutlined /> // 오름차순
                              : ""}
                          </span>
                        )}
                        </ThDiv>
                      </th>
                    );
                  }

                  // set 3
                  if (label === "공제액")
                    return (
                      <th
                        key={uuid()}
                        onClick={() =>
                          setOpenDepth({ ...openDepth, tax: !openDepth.tax })
                        }
                      >
                        <ThDiv>
                          {label}
                          {openDepth.extra ? (
                            <CP.Icon.MinusIcon />
                          ) : (
                            <CP.Icon.PlusIcon />
                          )}
                        </ThDiv>
                      </th>
                    );
                  if ([
                    "소득세", "주민세", "국민연금(4.50%)", "건강보험(3.50%)", "장기요양보험(12.27%)",
                    "고용보험(0.80%)", "건강보험정산", "장기요양정산",
                    "학자금공제", "근태공제", "기타공제"
                  ].includes(label)) {
                    return (
                      <th
                        {...column.getHeaderProps(column.getSortByToggleProps())}
                        key={uuid()}
                        className="subMenu "
                      >
                        <ThDiv>
                          {label}{" "}
                          {!column.disableSortBy && (
                          <span>
                            {column.isSorted
                              ? column.isSortedDesc
                                ? <CaretDownOutlined /> // 내림차순
                                : <CaretUpOutlined /> // 오름차순
                              : ""}
                          </span>
                        )}
                        </ThDiv>
                      </th>
                    );
                  }

                  // set 4
                  if (label === "연말정산")
                    return (
                      <th
                        style={{
                          width: column.width,
                          maxWidth: column.width,
                          cursor: isSort ? "pointer" : "default"
                        }}
                        key={uuid()}
                        className="subMenu"
                        onClick={() =>
                          setOpenDepth({
                            ...openDepth,
                            yearEnd: !openDepth.yearEnd
                          })
                        }
                      >
                        <ThDiv>
                          {label}
                          {openDepth.yearEnd ? (
                            <CP.Icon.MinusIcon />
                          ) : (
                            <CP.Icon.PlusIcon />
                          )}
                        </ThDiv>
                      </th>
                    );
                  if ([
                    "연말정산 소득세", "연말정산 주민세"
                  ].includes(label)) {
                    return (
                      <th
                        {...column.getHeaderProps(column.getSortByToggleProps())}
                        key={uuid()}
                        className="subMenu3 "
                      >
                        <ThDiv>
                          {label}{" "}
                          {!column.disableSortBy && (
                          <span>
                            {column.isSorted
                              ? column.isSortedDesc
                                ? <CaretDownOutlined /> // 내림차순
                                : <CaretUpOutlined /> // 오름차순
                              : ""}
                          </span>
                        )}
                        </ThDiv>
                      </th>
                    );
                  }


                  if (label === "급여명세서")
                    return (
                      <th
                        key={uuid()}
                        style={{borderRight: "none"}}
                      >
                        <ThDiv>
                          {label}
                        </ThDiv>
                      </th>
                    );  


                  return (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      className={column?.id ? column.id : ""}
                      key={uuid()}
                    >
                      <div
                        // {...column.getResizerProps()}
                      >
                        {label}{" "}
                        {!column.disableSortBy && (
                          <span>
                            {column.isSorted
                              ? column.isSortedDesc
                                ? <CaretDownOutlined /> // 내림차순
                                : <CaretUpOutlined /> // 오름차순
                              : ""}
                          </span>
                        )}
                      </div>
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>
    )
}

const ThDiv = styled.div<{ check?: boolean }>`
  /* border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc; */

  background: #f9f9f9;
  padding: 12px 16px;
  height: 100%;
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;

  ${(props) =>
    props.check === true &&
    css`
      display: flex;
      //  height : 40px
      padding: 0px;
      justify-content: center;
      align-items: center;
    `}
`;